import React from "react"

const Mission = () => {
  return (
    <>
      <div className="display">
        <div className="container">
          <div className="inner-display">
            <h1>Our mission</h1>
            <p>
              To Help India Achieve its smart City Objective, by Providing
              Innovation, Best in Class Consulting, Solutions and services. We
              shall make a joy for all stakeholders to work with us.
            </p>
          </div>
        </div>
      </div>
    </>
  )
}

export default Mission
